import { HStack, Input, VStack } from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";

import { OtpTimer } from "./otpTimer";

const OtpInput: React.FC<{length : number, onOtpSubmit: (combinedOtp: string) => void, verifyClicked: boolean}> =
    ({ length, onOtpSubmit }) => {
    const [otp, setOtp] = useState(new Array(length).fill(""));
    const inputRefs = useRef<(HTMLInputElement | null)[]>([]); // Explicitly define the type

    useEffect(() => {
        if (inputRefs.current[0]) {
        inputRefs.current[0].focus();
        }
    }, []);

    const handleChange = (index: number, e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (isNaN(Number(value))) return; // Convert value to number for validation

        const newOtp = [...otp];
        // allow only one input
        newOtp[index] = value.substring(value.length - 1);
        setOtp(newOtp);

        // submit trigger
        const combinedOtp = newOtp.join("");
        if (combinedOtp.length === length) onOtpSubmit(combinedOtp);

        // Move to next input if current field is filled
        if (value && index < length - 1 && inputRefs.current[index + 1]) {
        inputRefs.current[index + 1]?.focus();
        }
    };

    const handleClick = (index: number) => {
        inputRefs.current[index]?.setSelectionRange(1, 1);

        // optional
        if (index > 0 && !otp[index - 1]) {
        const emptyIndex = otp.indexOf("");
        if (emptyIndex !== -1) {
            inputRefs.current[emptyIndex]?.focus();
        }
        }
    };

    const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
        if (
        e.key === "Backspace" &&
        !otp[index] &&
        index > 0 &&
        inputRefs.current[index - 1]
        ) {
        // Move focus to the previous input field on backspace
        inputRefs.current[index - 1]?.focus();
        }
    };

    return (
        <VStack>
            <HStack height="2.5rem" borderColor="white" alignContent="center" justifyContent="flex-start">
            {otp.map((value, index) => {
                return (
                <Input
                    borderRadius="0.5rem"
                    borderColor="GrayText"
                    background="rgba(108, 117, 125, 0.08)"
                    key={index}
                    type="text"
                    height="100%"
                    marginY="0.5rem"
                    textAlign="center"
                    ref={(input) => (inputRefs.current[index] = input)}
                    value={value}
                    onChange={(e) => handleChange(index, e)}
                    onClick={() => handleClick(index)}
                    onKeyDown={(e) => handleKeyDown(index, e)}
                />
                );
            })}
            </HStack>
            <OtpTimer/>
        </VStack>
    );
};

export default OtpInput;
